<div class="flex items-center">
  <p-treeSelect
    [options]="groupedWorkspaces()"
    [filter]="true"
    [disabled]="availableWorkspacesForUser().length === 1"
    (onNodeSelect)="onWorkspaceChange($event.node.data)"
    (onShow)="trackSwitcherOpened()"
    [(ngModel)]="selectedWorkspaceTreeNode"
    class="flx-prime-tree-select small dark"
    panelStyleClass="flx-prime-tree-select small dark workspaces-switch-panel"
    filterPlaceholder="Search by workspace"
    emptyMessage="No workspaces found"
    appendTo="body"
    data-testId="workspace-tree-select"
  >
    <ng-template
      let-node
      pTemplate="group"
    >
      <span class="cursor-default">
        <flx-workspace-env-type-tag
          [envType]="node.key"
          [name]="node.label"
        />
      </span>
    </ng-template>
    <ng-template
      let-node
      pTemplate="item"
    >
      <div class="flex items-center w-full min-w-0">
        <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
      </div>
    </ng-template>
    <ng-template
      let-expanded
      pTemplate="itemtogglericon"
    >
      <i
        [class]="expanded ? 'ph-caret-down' : 'ph-caret-right'"
        class="ph text-base"
      ></i>
    </ng-template>
    <ng-template pTemplate="dropdownicon">
      <i class="ph ph-caret-down text-base"></i>
    </ng-template>

    <ng-template
      let-node
      pTemplate="value"
    >
      <div class="flex items-center gap-2 min-w-0">
        @if (selectedWorkspace(); as workspace) {
          <flx-workspace-env-type-tag
            [envType]="workspace.envType"
            [name]="workspace.envType"
          />
        }
        <div class="flex min-w-0 max-w-header-name">
          <ng-container
            *ngTemplateOutlet="label; context: { $implicit: node ?? {}, tooltipPosition: 'bottom' }"
          ></ng-container>
        </div>
      </div>
    </ng-template>
  </p-treeSelect>
</div>

<!-- The full name, only while it is cut. The header field opens it below, like the header's other tooltips. -->
<ng-template
  #label
  let-node
  let-tooltipPosition="tooltipPosition"
>
  <div
    [pTooltip]="node.label"
    [tooltipPosition]="tooltipPosition ?? 'right'"
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    [attr.data-testId]="'workspace_' + node.label"
    class="truncate"
    showOnEllipsis
  >
    {{ node.label }}
  </div>
</ng-template>
